import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "24",
  fill: "none",
  viewBox: "0 0 20 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M6.812 19.01c.385 0 .639-.24.628-.588L7.126 7.744c-.01-.35-.263-.579-.628-.579-.385 0-.639.24-.629.589l.304 10.668c.01.359.264.588.639.588m3 0c.386 0 .66-.24.66-.588V7.754c0-.35-.274-.589-.66-.589-.385 0-.648.24-.648.589v10.668c0 .349.263.588.648.588m3.011 0c.365 0 .618-.23.629-.588l.304-10.668c.01-.35-.244-.589-.629-.589-.365 0-.618.23-.628.589l-.304 10.668c-.01.349.243.588.628.588M5.363 4.56h1.611V2.426c0-.569.406-.938 1.014-.938h3.629c.608 0 1.013.37 1.013.938v2.136h1.612V2.325C14.242.878 13.29 0 11.728 0H7.876c-1.56 0-2.514.878-2.514 2.325zM.76 5.36h18.115a.76.76 0 0 0 .75-.759.75.75 0 0 0-.75-.748H.76c-.405 0-.76.34-.76.748 0 .42.355.759.76.759m4.41 16.865h9.295c1.45 0 2.423-.928 2.494-2.355l.71-14.7h-1.633l-.679 14.53c-.02.599-.456 1.018-1.054 1.018H5.312c-.578 0-1.014-.43-1.044-1.018l-.72-14.53H1.956l.72 14.71c.071 1.427 1.024 2.345 2.494 2.345"
    }, null, -1)
  ]))]))
}
export default { render: render }